<template>
  <Tag v-if="status === 'NORMAL'" type="success">已回复</Tag>
  <Tag v-else-if="status === 'PENDING'" type="warning">审核中</Tag>
  <Tag v-else-if="status === 'FAILURE'" type="danger">被驳回</Tag>
  <Tag v-else-if="status === 'FINISH'" type="primary">已完成</Tag>
</template>
<script>

import { Tag } from 'vant'
import 'vant/es/tag/style'

export default {
  name: 'ComplaintStatus',
  components: { Tag },
  props: {
    status: {
      type: String,
      default: 'NORMAL'
    }
  }
}
</script>
